import React from "react";
import "./FadingSpinner.css";

const FadingSpinner = ({ size = "3x" }) => (
  <div className={`la-ball-pulse la-dark la-${size}`}>
    <div></div>
    <div></div>
    <div></div>
  </div>
);

export default FadingSpinner;
